<template>
  <!-- 签署担保合同 -->
  <div>
    <div class="signingSecurityContractStyle">
      <Form
        :model="form"
        :rules="rules"
        v-model="regular"
      >
        <Input
          class="temr"
          label="银行名称"
          v-model="form.bankName"
          :readonly="true"
          :labelWidth="labelWidth"
        />
        <SelfSelect
          label="银行卡号"
          placeholder="请选择银行卡号"
          @selectValues="selectValues"
          v-model="form.cardNo"
          :columnsTerm="form.cardInfo"
          :labelWidth="labelWidth"
          :defaultValue="defaultCardNo"
        />
        <Input
          class="temr"
          label="担保费金额"
          v-model="form.securityAmount"
          :readonly="true"
          :labelWidth="labelWidth"
        />
        <Input
          class="temr"
          label="担保费率"
          v-model="form.securityRate"
          :readonly="true"
          :labelWidth="labelWidth"
        />
      </Form>
    </div>
    <Contract
      text="本人已阅读并完全同意"
      :list="contractList"
      :defaultCheck="false"
      v-model="isAgree"
    />
    <div class="submitTips">
      您的支用申请已审批通过，请先缴纳担保费，<span>担保费总额=贷款本金X担保费率。贷款期限3-12期（含），担保费率3%；13-24期（含），担保费率4%；25-36期（含），担保费率5%。</span>
    </div>
    <div class="btnBox">
      <Button
        text="下一步"
        type="danger"
        class="nextStep"
        :disabled="isDisabled"
        :click="goToNextPage"
      />
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import Button from '@/components/Button.vue';
import Contract from '@/components/Contract.vue';
import ServerBank from '@/components/ServerBank.vue';
import ContractStatus from './components/ContractStatus.vue';
import TwoItemField from './components/TwoItemField.vue';
import TipsText from './components/TipsText.vue';
import SelfSelect from './components/SelfSelect.vue';

export default {
  name: 'signingSecurityContractStandard',
  data() {
    return {
      contractList: [
        {
          text: '委托扣款协议书',
          value: 'YiLianKKAuth',
        },
        {
          text: '担保服务合同',
          value: 'yl_db',
        },
      ],
      isAgree: false,

      labelWidth: '129px',
      pageData: {},
      defaultCardNo: '',
      form: {
        bankName: '',
        cardNo: '',
        securityAmount: '',
        securityRate: '',
        typeList: ['yl_db'],
      },
      rules: {
        bankName: [{ required: true }],
      },
      regular: false,
    };
  },
  components: {
    Button,
    Contract,
    ServerBank,
    ContractStatus,
    TwoItemField,
    TipsText,
    SelfSelect,
  },
  mounted() {
    this.getContractInfo();
  },
  methods: {
    ...mapMutations('commonForms', ['updateForm']),
    selectValues(data) {
      this.form.bankName = data.value;
    },
    // 后端进行跳转
    jumpCurrPage() {
      const { orderId } = this.$route.query;
      this.$api.PublicPage.jumpCurrPage({
        orderId: orderId || localStorage.getItem('orderId'),
      }).then((res) => {
        if (res.success) {
          if (res.data) {
            window.location.href = res.data;
          }
        } else {
          this.$dialog.alert({
            title: '提示',
            message: '操作失败',
          });
        }
      });
    },
    // 查询合同信息
    async getContractInfo() {
      const { data, success, returnMessage } = await this.$api.OtherPage.queryEchoInfo({
        pageId: this.$route.query.pageId, // 0:进件页面 1:授信合同签署页面 2:提款申请页面 3:提款合同签署页面 4:还款试算页面 10:签署担保合同
        orderId: this.$route.query.orderId,
      });
      if (!success) {
        this.$toast(returnMessage || '获取数据失败');
        return;
      }
      this.$toast.clear();
      this.form = {
        ...data,
      };
      this.defaultCardNo = data.cardInfo[0].text.split('-')[0];
    },
    // 后端控制页面跳转
    goToNextPage() {
      if (this.pageData.url) {
        window.location.href = this.pageData.url;
        return;
      }
      this.$loading.show();
      const { orderId, pageId } = this.$route.query;
      if (orderId) {
        this.updateForm({
          orderId,
        });
      }
      this.$api.OtherPage.commitApply({
        ...this.form,
        orderId: orderId || localStorage.getItem('orderId'),
        pageId, // 0:进件页面 1:授信合同签署页面 2:提款申请页面 3:提款合同签署页面 4:还款试算页面 5、提款成功 6、还款成功 7、税务授权一 8、税务授权二 9、核心企业选择页 10:签署担保合同
      }).then((res) => {
        this.$loading.hide();
        if (res.success) {
          // this.jumpCurrPage();
          this.$router.push(`/supermarket/v2/loanInfoExplain?orderId=${orderId}`);
        } else {
          this.$toast(res.returnMessage || '提交失败');
        }
      });
    },
  },
  computed: {
    ...mapState({
      commonForms(val) {
        return val.commonForms;
      },
    }),
    isDisabled() {
      return !(this.form.bankName && this.isAgree);
    },
  },
};
</script>
<style lang="scss" scoped>
.signingSecurityContractStyle {
  width: 100%;
  height: 100%;
  background-color: #fff;
  box-sizing: border-box;
  padding: 15px;
  font-size: 15px;
  >>> .agreement {
    margin-left: 0px;
    margin-top: 20px;
  }
}
.contentStyle {
  box-shadow: border-box;
  padding-left: 40px;
  text-align: left;
}
.btnBox {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  padding-left: 15px;
  padding-right: 15px;
  margin-top: 15px;
}
.nextStep {
  width: 100%;
  padding: 0;
  border-radius: 3px;
  margin-top: 10px;
}
.submitTips {
  font-size: 12px;
  color: #c7c7c7;
  padding: 15px;
  text-align: left;
  font-weight: 600;
  span {
    color: red;
  }
}
</style>
